import React from 'react';
import './Comparison.css';

const Comparison = () => {
  return (
    <section id="comparison" className="comparison-section">
      <div className="container">
        <div className="section-header-new">
          <h2>CodeAlignR AI vs. Traditional Methods</h2>
          <p>See why AI-powered solutions outperform traditional approaches</p>
        </div>
        <div className="comparison-table">
          <div className="comparison-header">
            <div className="comparison-cell feature-header">
              <i className="fas fa-list-alt"></i>
              <span>Feature</span>
            </div>
            <div className="comparison-cell ai-header">
              <i className="fas fa-robot"></i>
              <span>CodeAlignR AI</span>
            </div>
            <div className="comparison-cell traditional-header">
              <i className="fas fa-user-tie"></i>
              <span>Traditional Hiring</span>
            </div>
          </div>
          <div className="comparison-row">
            <div className="comparison-cell feature">
              <i className="fas fa-clock"></i>
              <span>Availability</span>
            </div>
            <div className="comparison-cell ai">
              <i className="fas fa-check"></i>
              <span>24/7, never off duty</span>
            </div>
            <div className="comparison-cell traditional">
              <i className="fas fa-times"></i>
              <span>Limited to business hours</span>
            </div>
          </div>
          <div className="comparison-row">
            <div className="comparison-cell feature">
              <i className="fas fa-bolt"></i>
              <span>Response Time</span>
            </div>
            <div className="comparison-cell ai">
              <i className="fas fa-check"></i>
              <span>Instant replies, no hold time</span>
            </div>
            <div className="comparison-cell traditional">
              <i className="fas fa-times"></i>
              <span>Customers wait on hold</span>
            </div>
          </div>
          <div className="comparison-row">
            <div className="comparison-cell feature">
              <i className="fas fa-dollar-sign"></i>
              <span>Cost</span>
            </div>
            <div className="comparison-cell ai">
              <i className="fas fa-check"></i>
              <span>Low cost, no salaries or training</span>
            </div>
            <div className="comparison-cell traditional">
              <i className="fas fa-times"></i>
              <span>High cost, salaries + overhead</span>
            </div>
          </div>
          <div className="comparison-row">
            <div className="comparison-cell feature">
              <i className="fas fa-expand-arrows-alt"></i>
              <span>Scalability</span>
            </div>
            <div className="comparison-cell ai">
              <i className="fas fa-check"></i>
              <span>Handles unlimited calls/messages</span>
            </div>
            <div className="comparison-cell traditional">
              <i className="fas fa-times"></i>
              <span>Limited by team size</span>
            </div>
          </div>
          <div className="comparison-row">
            <div className="comparison-cell feature">
              <i className="fas fa-language"></i>
              <span>Language Support</span>
            </div>
            <div className="comparison-cell ai">
              <i className="fas fa-check"></i>
              <span>Multiple languages supported</span>
            </div>
            <div className="comparison-cell traditional">
              <i className="fas fa-times"></i>
              <span>Limited to staff languages</span>
            </div>
          </div>
          <div className="comparison-row">
            <div className="comparison-cell feature">
              <i className="fas fa-chart-line"></i>
              <span>Consistency</span>
            </div>
            <div className="comparison-cell ai">
              <i className="fas fa-check"></i>
              <span>100% accurate, no mood swings</span>
            </div>
            <div className="comparison-cell traditional">
              <i className="fas fa-times"></i>
              <span>Varies by employee</span>
            </div>
          </div>
        </div>
        <div className="comparison-cta">
          <a href="#contact" className="btn-primary-new">
            <i className="fas fa-calendar"></i>
            Book a Free Consultation
          </a>
        </div>
      </div>
    </section>
  );
};

export default Comparison;
